import Swiper from "swiper/bundle";

export const slider = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const swiper = new Swiper(".swiper-container", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      loop: true,
      centeredSlides: true,
      spaceBetween: 40,
      slidesPerView: 1,
      autoHeight: true,
      observeParents: true,
      observer: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
};
